module.exports = __webpack_public_path__ + "images/emoji/confused.6749cdff8b3693d7686f.png";